// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","container":"Footer_container__iICw7","name":"Footer_name__xI97K","address":"Footer_address__aD4II"};